var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFullMarket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 78,
    rx: 39,
    fill: "#F8FAFC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.8461 54.4552V59.4871H44.0317V55.8929L46.9071 53.0176L50.5012 56.6117L52.6577 54.4552L54.8142 56.6117L58.4084 53.0176L59.8461 54.4552Z",
    fill: "#475569"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8461 43.6724V54.4549L58.4084 53.0172L54.8142 56.6114L52.6577 54.4549L50.5012 56.6114L46.9071 53.0172L44.0317 55.8925V52.2984L48.3447 47.9854L51.9389 51.5795L59.8461 43.6724Z",
    fill: "#94A3B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6259 53.7364V59.4871H44.0317V55.8929L46.9071 53.0176L47.6259 53.7364Z",
    fill: "#64748B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1418 49.7824L47.6259 52.2984V53.736L46.9071 53.0172L44.0317 55.8925V52.2984L48.3447 47.9854L50.1418 49.7824Z",
    fill: "#64748B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8464 43.6724V47.2665L55.5334 51.5795L53.7363 49.7824L59.8464 43.6724Z",
    fill: "#64748B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7798 45.1099H29.6551V56.6112H26.7798V45.1099Z",
    fill: "#475569"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0293 49.4229H23.9046V56.6112H21.0293V49.4229Z",
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5308 42.2349H35.4061V56.6115H32.5308V42.2349Z",
    fill: "#94A3B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7798 45.1099H28.2175V56.6112H26.7798V45.1099Z",
    fill: "#64748B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0293 49.4229H22.467V56.6112H21.0293V49.4229Z",
    fill: "#475569"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5308 42.2349H33.9684V56.6115H32.5308V42.2349Z",
    fill: "#64748B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9694 22.138C39.9279 23.6299 40.4375 25.3659 40.4376 27.1393H31.0928V17.7944C32.6646 17.8 34.2097 18.2007 35.5861 18.9597C36.9625 19.7188 38.1259 20.8117 38.9694 22.138Z",
    fill: "#94A3B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4426 36.9581C33.5695 37.937 32.4998 38.7209 31.3033 39.2584C30.1068 39.796 28.8104 40.0752 27.4986 40.0779C22.3725 40.0779 18.1538 35.8592 18.1538 30.733C18.1538 25.6068 22.3725 21.3882 27.4986 21.3882V30.733H36.8435C36.8408 33.0336 35.9854 35.2515 34.4426 36.9581Z",
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6869 18.5223V27.1393H31.0928V17.7944C32.3275 17.7935 33.5498 18.041 34.6869 18.5223Z",
    fill: "#64748B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2975 39.9017C28.7051 40.0192 28.1026 40.0782 27.4986 40.0779C22.3725 40.0779 18.1538 35.8592 18.1538 30.733C18.1538 25.6068 22.3725 21.3882 27.4986 21.3882V22.116C24.1345 23.5357 21.748 26.8774 21.748 30.733C21.748 35.2455 25.0178 39.0553 29.2975 39.9017Z",
    fill: "#475569"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3521 24.7725L36.3354 23.7559L39.9296 20.1617C39.9964 20.095 40.0756 20.042 40.1628 20.0059C40.25 19.9698 40.3435 19.9512 40.4379 19.9512H46.1886V21.3888H40.7356L37.3521 24.7725Z",
    fill: "#475569"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1882 38.6406H35.4057C35.3113 38.6406 35.2178 38.6221 35.1306 38.5859C35.0434 38.5498 34.9641 38.4969 34.8974 38.4301L31.3032 34.8359L32.3198 33.8193L35.7034 37.203H46.1882V38.6406Z",
    fill: "#475569"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0001 60.2058H18.1539C17.9632 60.2058 17.7804 60.13 17.6456 59.9952C17.5108 59.8604 17.4351 59.6776 17.4351 59.4869V41.5161H18.8727V58.7681H39.0001V60.2058Z",
    fill: "#475569"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.626 19.9512H53.3766V21.3888H47.626V19.9512Z",
    fill: "#94A3B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.626 22.8267H53.3766V24.2643H47.626V22.8267Z",
    fill: "#94A3B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.626 25.7012H53.3766V27.1388H47.626V25.7012Z",
    fill: "#94A3B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8145 22.8267H60.5651V24.2643H54.8145V22.8267Z",
    fill: "#94A3B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8145 25.7012H60.5651V27.1388H54.8145V25.7012Z",
    fill: "#94A3B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.626 37.2031H53.3766V38.6408H47.626V37.2031Z",
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8145 37.2031H60.5651V38.6408H54.8145V37.2031Z",
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.626 34.3281H53.3766V35.7658H47.626V34.3281Z",
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8145 34.3281H60.5651V35.7658H54.8145V34.3281Z",
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.626 31.4526H53.3766V32.8903H47.626V31.4526Z",
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8145 31.4526H60.5651V32.8903H54.8145V31.4526Z",
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5653 60.2058H41.1568C40.9662 60.2058 40.7833 60.13 40.6485 59.9952C40.5137 59.8604 40.438 59.6776 40.438 59.4869V41.5161H41.8757V58.7681H60.5653V60.2058Z",
    fill: "#475569"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullMarket);
export default __webpack_public_path__ + "static/media/FullMarket.3a305c839989f1eaea606fdd914a0100.svg";
export { ForwardRef as ReactComponent };